export function badge_id(state){
    return state.badge_id
}

export function message_id(state){
    return state.message_id
}

export function news_id(state){
    return state.news_id
}